import React from "react"

function Container({ children }) {
  return (
    <table role="presentation" className="email-container">
      <tbody>
        <tr>
          <td>
            <table
              role="presentation"
              border="0"
              cellPadding="0"
              cellSpacing="0"
            >
              <tbody>
                <tr>
                  <td>{children}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default Container
